<template>
    <div style="margin-top:0.5rem;text-align:center;">
        <div v-if="count === 0">
            <div style="width:68px;height:68px;margin-left:auto;margin-right:auto;">
              <img src="/res/icon/info.png" style="filter:alpha(Opacity=20);-moz-opacity:0.2;opacity:0.2;width:100%;height:100%;" />
            </div>
            <div style="text-align:center;padding:10px;font-size:0.8rem;color:#9e9e9e;margin-top:0.2rem;">没有相关记录 !</div>
        </div>
        <div v-else>
            <div style="text-align:center;padding:10px;font-size:0.8rem;color:#9e9e9e;">没有更多数据 !</div>
        </div>
    </div>
</template>

<script>
export default {
  components: {},
  props: {
    count: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {

    }
  },
  computed: {
  },
  mounted() {
  },
  created() {
  },
  methods: {
  }
}
</script>

<style scoped>
</style>
